<template>
  <div id="app">
    <h1 class="title is-1">JMESPath Tester</h1>
    <Inputs />


    <footer class="footer">
      <div class="content has-text-centered">
        <p>
          <a href="https://bulma.io"  target="blank" rel="external">JMESPath</a> |
          <a href="http://jmespath.org/"  target="blank" rel="external">Bulma</a> |
          <a href="https://vuejs.org/"  target="blank" rel="external">VueJS</a>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import Inputs from './components/Inputs.vue'

export default {
  name: 'app',
  components: {
    Inputs
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
